<template>
  <div
    class="dataPosterFull"
    id="containerFull_body"
    :class="isFullScreenFlag ? 'fullScreen' : ''"
    v-if="currThemeObj"
  >
    <div class="fix_header">
      <platfrom_menu
        :currThemeObj="currThemeObj"
        :selectData="platfromMenu_selectData"
        :userInfor="platfromMenu_userInfor"
        :groupList="platfromMenu_groupList"
        :currGroup="platfromMenu_currGroup"
        :curPageInitNum="containerFull_curPageInitNum"
        @changeGroupEvent="platfromMenu_changeGroup"
      ></platfrom_menu>
    </div>
    <div class="mix_body">
      <router-view
        :axiosBaseUrl="axiosBaseUrl"
        :currGroup="platfromMenu_currGroup"
        :groupChangeInitPage="containThemeRouteName"
        :currThemeObj="currThemeObj"
        :sportsTypeArr="sportsTypeArr"
        :curPageInitNum="containerFull_curPageInitNum"
        :isFullScreenFlag="isFullScreenFlag"
      ></router-view>
    </div>

    <div class="mix_footer">
      <component :is="footerCustomDom" :currThemeObj="currThemeObj" />
    </div>
    <!-- <publicThemeDialog
      v-if="isShowPublicThemeDialog"
      :currThemeObj="currThemeObj"
      :isDialogFlag="isShowPublicThemeDialog"
      :dialogObj="publicThemeDialogObj"
      :axiosBaseUrl="axiosBaseUrl"
      :currGroup="platfromMenu_currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :curTimeZoneItem="platfromMenu_curTimeZoneItem"
      @publicThemeDialogEvent="publicThemeDialogHandler"
      @actStyleItemEvent="actStyleItemEventHandler"
    ></publicThemeDialog> -->
  </div>
</template>

<script>
// 数据海报 容器
import platfrom_menu from '@components/platfromBase/dataPoster/home_menu/index.vue'
import customizeProMixins_data_mixin from '@customizeProMixins/index.js'
import { https_manage_getGroupData } from '@api/platfrom_base_api'

export default {
  name: 'dataPosterFull',
  mixins: [customizeProMixins_data_mixin],
  components: {
    platfrom_menu,
    // publicThemeDialog,
  },
  data() {
    return {
      dynamicConfig: null,
      sportsTypeArr: ['combat', 'uncombat'],
      defaultPath: ['dataPoster', 'default', 'posterLibrary'],
      axiosBaseUrl: '/dataposter',
      platfromMenu_selectData: [],
      platfromMenu_userInfor: {
        companyName: '',
        email: '',
        identy: '',
        role: '',
        station: null,
        stationName: '',
        userAlias: '',
        userId: '',
      },
      platfromMenu_groupList: [],
      platfromMenu_currGroup: null,
      containThemeRouteName: [
        // 当组id变化时，这些页面重新加载数据
      ],
      containerFull_curPageInitNum: 0,
      //   isShowPublicThemeDialog: false,
      //   publicThemeDialogObj: null,
      //   popInfor: {
      //     infor: '',
      //     btnName: '加载',
      //   },
      isFullScreenFlag: false,
    }
  },
  watch: {
    $route(to, from) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致
      console.debug(from.name, to.name)
    },
  },
  beforeCreate() {
    this.dynamicConfig = this.$dynamicConfig
  },
  created() {
    // let queryParams = this.$route.query
    // const fullPath = this.$route.fullPath
    // const pathModule = this.$route.meta.pathModule
    // console.debug('this.$route:', this.$route, fullPath)
    this.init()
  },
  computed: {
    currThemeObj() {
      console.debug('currThemeObj发生变化')
      let currThemeObj = null
      // this.$dynamicConfig.includeTheme.football.FIFAWC_107
      currThemeObj =
        this.$dynamicConfig.includeTheme.dataPoster.dataPoster_default[0]
      if (!currThemeObj) {
        console.error('暂不支持同时查看多个赛事项目')
      } else {
        // 数据包装的日期下拉框和时间下拉框需要这些颜色
        const colorKeys = Object.keys(currThemeObj.cssStyle)
        const styleArr = []
        colorKeys.forEach((key) => {
          if (key) {
            styleArr.push(`--mixtmt_${key}:${currThemeObj.cssStyle[key]}`)
          }
        })
        if (currThemeObj.comImgStyle) {
          // 设置普通的图片
          currThemeObj.comImgStyle.forEach((imgName) => {
            if (imgName.indexOf('.') > -1) {
              styleArr.push(
                `--mixtmt_${imgName.split('.')[0]}: url(/static/${
                  currThemeObj.sportType
                }/${currThemeObj.imageUrl}/${imgName})`
              )
            }
          })
        }
        const styleId = `mixtmt_rootStyle`
        let styleDom = document.getElementById(styleId)
        if (!styleDom) {
          let styleDom = document.createElement('style')
          styleDom.id = styleId

          styleDom.textContent = `:root {${styleArr.join(';')}}`
          document.head.appendChild(styleDom)
        } else {
          styleDom.textContent = `:root {${styleArr.join(';')}}`
        }
      }

      console.debug('currThemeObj:', currThemeObj)
      return currThemeObj
    },
  },
  methods: {
    platfromMenu_changeGroup(item) {
      this.platfromMenu_groupList.forEach((val) => {
        if (item.groupId == val.groupId) {
          val.act = true
        } else {
          val.act = false
        }
      })
      this.platfromMenu_currGroup = item
      window.mixtmt_platfrom.currGroup = item
    },
    async init() {
      const userInfor = JSON.parse(
        this.$localStorage.getItem('mixtmt_userInfo')
      )
      if (userInfor) {
        this.platfromMenu_userInfor = userInfor
      }
      if (!window.mixtmt_platfrom.currGroup) {
        // 防止在大运会中刷新页面，没有组数据
        await this.getGroupData()
      } else {
        this.platfromMenu_currGroup = window.mixtmt_platfrom.currGroup
      }

      const groupList = JSON.parse(
        this.$localStorage.getItem('mixtmt_groupList')
      )
      if (groupList) {
        // 防止在home页切换组别，马拉松没有同步
        this.platfromMenu_groupList = groupList
        this.platfromMenu_groupList.forEach((val) => {
          if (this.platfromMenu_currGroup.groupId == val.groupId) {
            val.act = true
          } else {
            val.act = false
          }
        })
      }
      // 获取赛季列表
      //   await this.getSeasonList({ cid: this.currCid })
    },
    async getSeasonList(query) {
      await https_badminton_seasonList(this.axiosBaseUrl, this.$axios, query)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.platfromMenu_selectData = res.data
              ? res.data.map((val, index) => ({
                  cid: query.cid,
                  name: val.seasonName,
                  key: val.seasonId,
                  logoImage: val.seasonLogo,
                  act: this.currSid
                    ? this.currSid == val.seasonId
                      ? true
                      : false
                    : index == 0
                    ? true
                    : false,
                }))
              : []
            // this.currSid = 1072020
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getGroupData() {
      await https_manage_getGroupData('/api', this.$axios)
        .then((response) => {
          const res = response.data
          console.debug('正常')
          if (res.status === 0) {
            // 测试切换组
            // res.data = res.data.concat({
            //   groupId: '06476a49-3db4-4b4c-91b3-b228714d6000',
            //   groupName: '测试切换',
            // })

            this.platfromMenu_groupList = res.data
              ? res.data.map((item, index) => {
                  if (index == 0) {
                    item.act = true
                    this.platfromMenu_currGroup = item
                    window.mixtmt_platfrom.currGroup = item
                  } else {
                    item.act = false
                  }
                  return item
                })
              : []
            this.$localStorage.setItem(
              'mixtmt_groupList',
              JSON.stringify(res.data)
            )
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss">
.dataPosterFull {
  position: relative;
  width: 100%;
  /* height: auto; */
  font-size: 0.972vw;
  max-height: 100vh;
  overflow: auto;
  &.fullScreen {
    .mix_body {
      min-height: calc(100vh - 8vw - 9.722vw);
      padding: 0 !important;
    }
  }
  & .fix_header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1500;
    width: 100%;
    height: 8vw;
    background-color: var(--mixtmt_whiteColor);
  }
  & .mix_body {
    min-height: calc(100vh - 8vw - 9.722vw);
    padding: 0 9.722vw;
  }
  & .mix_footer {
    /* position: absolute;
          bottom: 0;
          left: 0;
          z-index: 1000; */
    width: 100%;
  }
}

.mixtmt_pc {
  .dataPosterFull {
    /* padding: 8vw 9.722vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
.mixtmt_ipad {
  .dataPosterFull {
    /* padding: 8vw 3vw 9.722vw; */
    padding: 8vw 0 0 0;
  }
}
</style>
